import CustomTooltip from '@components/tooltip/tooltip';
import { theme } from '@config/theme';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, ButtonBase, Chip, Typography } from '@mui/material';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
interface SpecialistCardProps {
	title: string;
	description?: string;
	label?: string;
	isActive?: boolean;
	cardClick?: () => void;
}

export const SpecialistCard: React.FC<SpecialistCardProps> = ({
	title,
	description,
	label,
	cardClick,
	isActive,
}) => {
	const { t } = useTranslation();

	return (
		<ButtonBase
			disabled={!isActive}
			onClick={cardClick}
			sx={{
				borderRadius: '10px',
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				opacity: isActive ? 1 : 0.5,
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: isActive
					? theme.palette.custom.veryLightCyan
					: theme.palette.custom.contrastTextWhite,
				boxShadow: theme.boxShadows.primary,
				height: '200px',
				padding: '10px',
			}}
			className="w-[600px] h-[200px] max-md:w-[390px] max-xsm:!w-[320px]"
		>
			{label && (
				<CustomTooltip
					placement="top"
					title={
						<Box className="flex items-center gap-[10px] text-blue">
							<InfoOutlinedIcon />
							<Typography>{t('switchLanguageLabel')}</Typography>
						</Box>
					}
				>
					<Chip
						label={label}
						variant="outlined"
						sx={{
							position: 'absolute',
							top: '10px',
							right: '10px',
							font: 'roboto-bold',
							backgroundColor: isActive ? theme.palette.custom.contrastTextWhite : '',
							border: `1px solid ${isActive ? theme.palette.custom.teal : '#FD3333'}`,
							borderRadius: '8px',
							width: 'max-content',
							padding: '1px 10px',
							height: '24px',
							fontWeight: '700',
							fontSize: '16px',
							'& .MuiChip-label': {
								color: isActive ? theme.palette.custom.teal : '#FD3333',
								padding: '0px',
							},
						}}
					/>
				</CustomTooltip>
			)}
			<div className="flex justify-center items-center">
				<h1
					className={classNames('text-dark roboto-medium text-[24px]', {
						'text-primary': isActive,
					})}
				>
					{title}
				</h1>
				<KeyboardArrowRightIcon
					sx={{
						color: isActive ? theme.palette.custom.teal : theme.palette.custom.darkGray,
					}}
				/>
			</div>
			{description && (
				<p className="text-secondary text-center text-[16px] roboto-regular-italic mt-[20px]">
					{description}
				</p>
			)}
		</ButtonBase>
	);
};
